import { Col, Row } from 'antd'
import React from 'react'

const PlanDetails = ({ plan }) => {
  
  return (
    <Row>
        
      <Col xs={ 24} >
        <h1
        >{plan?.name}</h1>
      </Col>
      <Col style={{
        display: 'flex',
        gap : "20px"
        
      }} xs={24}>
      <h1>Price</h1>
      
        {
          plan?.price 
        }
        ₹
      
      </Col>
      <Col style={{
        display: 'flex',
        gap : "20px"
        
      }} xs={24}>
      <h1>Duration (in days)</h1>
      
        {
          plan?.duration 
        }
        
      
      </Col>
      <Col >
        <h1>Benefits</h1>
      </Col>
      {
        plan?.benefits?.map((item) => {
          
          return <Col xs={24}>
        {item}
           
          </Col>
        })
      }
     
   </Row>
  )
}

export default PlanDetails